import React from 'react'

import { PlusIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import {
  IConditionalField,
  IPermitTypeField,
  PermitFieldType,
} from '~/client/graph'
import { Button } from '~/client/src/shared/components/Button/Button'
import { MAX_CONDITIONAL_FIELDS } from '~/client/src/shared/constants/permitTypeFieldsConstants'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { parseConditionalKeyIds } from '~/client/src/shared/utils/conditionalKeyUtils'

import FormFieldsModal from '../../../../FormFieldsModal'
import IDependentFieldsConfiguratorProps from '../types/IDependentFieldsConfiguratorProps'
import IDependentFieldsHandlersProps from '../types/IDependentFieldsHandlersProps'
import ConditionalField from './ConditionalField'

interface IProps {
  rule: IConditionalField
  isLBSToggleShown: boolean
  depthLevel: number
  restrictedFieldTypes: PermitFieldType[]
  mainContainerProps: IDependentFieldsConfiguratorProps
  handlers: IDependentFieldsHandlersProps
  tableConfiguratorRenderer: (field: IPermitTypeField) => JSX.Element
}

function ConditionalFieldList({
  rule,
  isLBSToggleShown,
  depthLevel,
  restrictedFieldTypes,
  mainContainerProps,
  handlers,
  tableConfiguratorRenderer,
}: IProps) {
  const canAddField = rule.values.length < MAX_CONDITIONAL_FIELDS
  const lbsLocationId = parseConditionalKeyIds(rule.key)[0] || rule.key

  return (
    <>
      {rule.values.map((conditionalField, idx) => (
        <ConditionalField
          key={conditionalField.id}
          conditionalField={conditionalField}
          canAddField={canAddField}
          restrictedFieldTypes={restrictedFieldTypes}
          isLBSToggleShown={isLBSToggleShown}
          lbsLocationId={lbsLocationId}
          depthLevel={depthLevel}
          tableConfiguratorRenderer={tableConfiguratorRenderer}
          mainContainerProps={mainContainerProps}
          onAddField={fieldType =>
            handlers.handleAddField(rule.key, idx, fieldType)
          }
          onUpdateField={field =>
            handlers.handleUpdateField(rule.key, idx, field)
          }
          onRemoveField={field => handlers.handleRemoveField(rule.key, field)}
        />
      ))}

      {!rule.values?.length && (
        <FormFieldsModal
          addNewField={(fieldType: PermitFieldType) => {
            handlers.handleAddField(rule.key, -1, fieldType)
          }}
          restrictedFields={restrictedFieldTypes}
        >
          <Button variant="primary-ghost" size="lg">
            <PlusIcon data-icon="inline-start" />
            {Localization.translator.addDependentField}
          </Button>
        </FormFieldsModal>
      )}
    </>
  )
}

export default observer(ConditionalFieldList)
